var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-text-center g-flexbox tabbar"},[_c('div',{staticClass:"g-flex tab",class:{
            on: _vm.currentPath === '/'
        },on:{"click":function($event){return _vm.go('/')}}},[_vm._v("\n        推荐\n    ")]),_vm._v(" "),_c('div',{staticClass:"g-flex tab",class:{
            on: _vm.currentPath === '/following'
        },on:{"click":function($event){return _vm.go('/following', true)}}},[_vm._v("\n        关注\n    ")]),_vm._v(" "),_c('div',{staticClass:"g-flex tab",class:{
            on: _vm.currentPath === '/rankboard'
        },on:{"click":function($event){return _vm.go('/rankboard')}}},[_vm._v("\n        热榜\n    ")]),_vm._v(" "),_c('div',{staticClass:"g-flex tab",class:{
            on: _vm.currentPath === '/home'
        },on:{"click":function($event){return _vm.go('/home', true)}}},[_vm._v("\n        我\n    ")]),_vm._v(" "),_c('auth-modal',{ref:"authModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }